import { Box, Divider, Flex } from '@chakra-ui/react';
import { NavSection } from '@aslanpay/portal-common-lib';

import BrandLogo from 'app/components/Branding/BrandLogo';
import PoweredByAslan from 'app/components/Branding/PoweredByAslan';

import SidebarShell from '../SidebarShell';

import AccountRow from './AccountRow';
import SidebarRow from './SidebarRow';

interface EmployeeSidebarProps {
  sections: NavSection[];
  activeId: string;
}

function SidebarContent({
  sections,
  activeId,
  onNavigate,
  accountVariant,
}: EmployeeSidebarProps & {
  onNavigate: () => void;
  accountVariant: 'flyout' | 'sheet';
}) {
  const items = sections.filter((section) => !section.hidden).flatMap((section) => section.items);

  return (
    <Flex direction="column" h="full" px="12px" pt="32px" pb="20px">
      <Flex px="12px" flexShrink={0}>
        <BrandLogo w="124px" />
      </Flex>

      <Divider borderColor="brand.navMuted" mt="24px" mb="20px" />

      <Flex as="nav" aria-label="Main navigation" direction="column">
        <Flex as="ul" direction="column" gap="4px" listStyleType="none" m="0" p="0">
          {items.map((item) => (
            <Box as="li" key={item.id} listStyleType="none">
              <SidebarRow
                to={item.path}
                isActive={activeId === item.id}
                icon={activeId === item.id && item.iconActive ? item.iconActive : item.icon}
                onClick={onNavigate}
                data-testid={`sidebar-nav-${item.id}`}
              >
                {item.label}
              </SidebarRow>
            </Box>
          ))}
        </Flex>
      </Flex>

      {/* Everything below is pushed to the bottom of the sidebar. */}
      <Box flex="1" minH="20px" />

      <Flex direction="column" gap="4px" flexShrink={0}>
        <Divider borderColor="brand.navMuted" my="15px" />

        <AccountRow variant={accountVariant} />
      </Flex>
    </Flex>
  );
}

/** The employee portal's only chrome: the pages, then the account. */
function EmployeeSidebar({ sections, activeId }: EmployeeSidebarProps) {
  return (
    <SidebarShell
      data-testid="employee-sidebar"
      bg="brand.sidebarLilac"
      controlColor="brand.darkPurple"
      drawerWidth="260px"
      mobileHeader={<BrandLogo w="96px" />}
      footer={<PoweredByAslan px="24px" pb="20px" />}
    >
      {({ onNavigate, isDrawer }) => (
        <SidebarContent
          sections={sections}
          activeId={activeId}
          onNavigate={onNavigate}
          accountVariant={isDrawer ? 'sheet' : 'flyout'}
        />
      )}
    </SidebarShell>
  );
}

export default EmployeeSidebar;
